module.exports = __webpack_public_path__ + "static/media/orange.8dc3285a.png";